import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import ObservationPrintCard from "./ObservationPrintCard";
import { IChild } from "./types/child";

const ObservationsPrintView: React.FC<{ child: IChild }> = ({ child }) => (
  <Box>
    <Typography variant="h4" marginTop={5} gutterBottom>
      Observations for {child.registration.childFirstName} {child.registration.childMiddleName} {child.registration.childLastName}
    </Typography>
    <Box>
      {child.observations
        .sort((a: any, b: any) => (new Date(b.observationDate) as any) - (new Date(a.observationDate) as any))
        .filter((observation: any) => observation.reviewed && observation.visibleToParents)
        .map((observation: any) => (
          <Box key={observation.id} sx={{ marginBottom: 2 }}>
            <ObservationPrintCard observation={observation} sx={{ width: '100%' }} />
          </Box>
        ))}
    </Box>
    <style>
      {`
        @media print {
          body {
            background: white !important;
          }
          .MuiPaper-root, .MuiCard-root {
            box-shadow: none !important;
            margin: 0 !important;
            page-break-inside: avoid;
          }
        }
      `}
    </style>
  </Box>
);

export default ObservationsPrintView;